import * as React from "react";
const SvgGrid2Solid = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 5V11H5V5H11ZM11 13V19H5V13H11ZM13 5H19V11H13V5ZM19 13V19H13V13H19Z", fill: "currentColor" }));
export default SvgGrid2Solid;
